import React from 'react';
import PropTypes from 'prop-types';

import './Loader.sass';

import cx from 'classnames';

export default function Loader({page, section, block, row, button, reviews, slider, alt}) {
  return (
    <React.Fragment>
      <div className={cx({
        'loader-container': true,
        'loader-container--page': page,
        'loader-container--section': section,
        'loader-container--block': block,
        'loader-container--row': row,
        'loader-container--button': button,
        'loader-container--reviews': reviews,
        'loader-container--slider': slider,
      })}>
        <span className={cx('loader', alt && 'loader--alt')}>
          <span className="loader__dot" />
          <span className="loader__dot" />
          <span className="loader__dot" />
          <span className="loader__dot" />
        </span>
      </div>
    </React.Fragment>
  );
}

Loader.propTypes = {
  page: PropTypes.bool,
  section: PropTypes.bool,
  block: PropTypes.bool,
  row: PropTypes.bool
};



// WEBPACK FOOTER //
// ./components/loader/Loader.js